import {
  defaultRangeExtractor,
  type Range
} from "@tanstack/react-virtual";

export const MODEL_CARD_MIN_WIDTH = 274;
export const MODEL_GRID_GAP = 9;

export function getGridColumnCount(
  width: number,
  minimumWidth = MODEL_CARD_MIN_WIDTH,
  gap = MODEL_GRID_GAP
): number {
  if (!Number.isFinite(width) || width <= 0) return 1;
  return Math.max(1, Math.floor((width + gap) / (minimumWidth + gap)));
}

export function chunkIntoRows<T>(items: T[], columns: number): T[][] {
  const safeColumns = Math.max(1, Math.floor(columns));
  const rows: T[][] = [];

  for (let index = 0; index < items.length; index += safeColumns) {
    rows.push(items.slice(index, index + safeColumns));
  }

  return rows;
}

export function extractStickyVirtualIndexes(
  range: Range,
  stickyIndexes: readonly number[],
  activeStickyIndex: number
): number[] {
  let stickyPosition = -1;
  for (let position = 0; position < stickyIndexes.length; position += 1) {
    const index = stickyIndexes[position];
    if (index === undefined) continue;
    if (index > range.startIndex) break;
    stickyPosition = position;
  }

  const indexes = defaultRangeExtractor(range);
  for (
    let position = Math.max(0, stickyPosition - 1);
    position <= Math.min(stickyIndexes.length - 1, stickyPosition + 1);
    position += 1
  ) {
    const index = stickyIndexes[position];
    if (index !== undefined) indexes.push(index);
  }
  if (activeStickyIndex >= 0) indexes.push(activeStickyIndex);

  return [...new Set(indexes)]
    .filter(
      (index) =>
        Number.isInteger(index) && index >= 0 && index < range.count
    )
    .sort((left, right) => left - right);
}
